// TODO: remove this hard coded image url once CMS is in place
export const imageUrl =
  'https://static.elisa.com/v2/image/2tqybbhjs47b/3BDHvyiFOCjVcn2C7VEaAP/5G-logo-uusi.png?w=128&fm=avif';

export const INSTALLATION_APPOINTMENT_TIME_SLOT_ID = 'installationAppointmentTimeSlotId';
